import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common'
import site from './modules/site'
import user from './modules/user'
import financial from './modules/financial'
import basis from './modules/basis'
import home from './modules/home'
import customer from './modules/customer'
import fetch from '../plugins/axios'
import { setRoute } from '../router'
Vue.use(Vuex);


export default new Vuex.Store({
  modules: {
    common,
    site,
    user,
    financial,
    basis,
    home,
    customer
  },
  state: {
    asideMenuList: [],
    baseInfo: {
      siteOrg:{
        children: []
      },
      comOrg: {},
      subSys: [],
      permisions: [],
    },
    dictionaries: {
      comArea: [],
      shelfType: [],
      siteType: [],
      clientRole: [],
    } //字典
  },
  getters: {
    // 公司区域
    comArea: state => {
      return state.dictionaries.comArea
    },
    // 组织架构
    siteOrg: state => {
      return state.baseInfo.siteOrg.children
    },
    permissionKeys: state => {
      const permisions = state.baseInfo.permisions;
      return state.baseInfo.permisions
    },
    // 模式
    shelfType: state => {
      return state.dictionaries.shelfType
    },
    // 门店类型
    siteType: state => {
      return state.dictionaries.siteType
    },
    // 角色
    clientRole: state => {
      return state.dictionaries.clientRole
    },
    // 所属系统
    subSys: state => {
      return state.baseInfo.subSys
    },
    // 快递公司列表
    excomList: (state:any) => {
      return state.dictionaries.connetion
    },
    // 登陆用户信息
    loginuser: (state:any) => {
      return state.baseInfo.user
    },
  },
  mutations: {
    setState(state:any,{ key, data }){
			state[key] = data;
		}
  },
  actions: {
    // 获得左侧菜单列表
    async getAsideMenu({ commit }){
			const res = await fetch({
				url: '/admin/menu'
      })
      commit('setState', { key: 'asideMenuList', data: res });
    },
    getMenuList({ commit }, params) {
      return fetch({
        url: '/admin/menu',
        params
      })
    },
    createMenu({commit}, data) {
      return fetch({
        url: '/admin/menu',
        method: 'POST',
        data,
      })
    },
    modifyMenu({commit}, data) {
      return fetch({
        url: `/admin/menu/${data._id}`,
        method: 'PUT',
        data,
      })
    },
    deleteMenu({commit}, id) {
      return fetch({
        url: `/admin/menu/${id}`,
        method: 'DELETE',
      })
    },
    getRoleList({ commit }, params) {
      return fetch({
        url: '/admin/role',
        params
      })
    },
    createRole({commit}, data) {
      return fetch({
        url: '/admin/role',
        method: 'POST',
        data,
      })
    },
    modifyRole({commit}, data) {
      return fetch({
        url: `/admin/role/${data._id}`,
        method: 'PUT',
        data,
      })
    },
    deleteRole({commit}, id) {
      return fetch({
        url: `/admin/role/${id}`,
        method: 'DELETE',
      })
    },
    async getInitData({ commit }){
			const res:any = await fetch({
				url: '/admin/baseInfo'
      })
      if(res) setRoute(res.permisions);
      commit('setState', { key: 'baseInfo', data: res });
    },
    async getDictionaries({ commit }){
			const res = await fetch({
				url: '/admin/dictionaries'
      })
      commit('setState', { key: 'dictionaries', data: res });
    },
    async login({ commit }: any, data: object) {
			return await fetch({
        url: '/admin/login',
        method: 'post',
        data,
      })
		},
    async logout() {
      return await fetch({
        url: '/admin/logout',
        method: 'get',
      })
    },
    getVcode() {
      return fetch({
        url: '/admin/vcode',
      })
    }
  },
});
